import React from "react";
import { HardHat } from "lucide-react";
import { useI18n } from "@/context/I18nContext";

export function ConstructionBadge({ className = "" }) {
  const { t } = useI18n();
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full px-2.5 py-1 text-[10px] font-semibold uppercase tracking-wider text-[#f59e0b] bg-[#f59e0b]/12 border border-[#f59e0b]/30 ${className}`}
      data-testid="construction-badge"
    >
      <HardHat className="w-3 h-3" />
      {t("calc.construction")}
    </span>
  );
}
